import { hexRound, hexRoundCorner } from '../Util/Coords';

export default class Mouse {

    static LEFT = 0;
    static RIGHT = 2;
    
    constructor() {
        this.buttons = {};
        this.lastMousePos = [0,0];
        this.currentMousePos = [0,0];
        this.currentWorldPos = [0,0];
        this.snapMousePos = [0,0];
        this.snapMode = 'center';
        this.snapPoint = [0,0];
        this.tileSize = 70;
    }

    setTileSize(size) {
        this.tileSize = size;
    }

    setButtonState(button, state) {
        this.buttons[button] = state;
    }

    isButtonPressed(button) {
        return !!this.buttons[button];
    }

    setRealPos(x, y) {
        this.lastMousePos = this.currentMousePos;
        this.currentMousePos = [x, y];
    }

    setWorldPos(x, y) {
        this.currentWorldPos = [x, y];
    }

    getDeltaPos() {
        return this.currentMousePos.map((a,i) => a - this.lastMousePos[i]);
    }

    findSnapPoint(mode, gridType = 'square') {
        if (gridType === 'hexagon') {
            const centerPoint = hexRound(this.currentWorldPos);
            const distanceFromCenter = Math.sqrt(Math.abs(centerPoint[0]-this.currentWorldPos[0])+Math.abs(centerPoint[1]-this.currentWorldPos[1]));

            switch (mode) {
                case 'auto':
                    if (distanceFromCenter < 0.6) {
                        this.snapMousePos = centerPoint
                    } else {
                        this.snapMousePos = hexRoundCorner(this.currentWorldPos, centerPoint);
                    }
                    break;
                case 'center':
                    this.snapMousePos = centerPoint;
                    break;
                case 'corner':
                    this.snapMousePos = hexRoundCorner(this.currentWorldPos, centerPoint);
                    break;
                default:
                    this.snapMousePos = this.currentWorldPos;
            }
        } else {
            switch (mode) {
                case 'auto':
                    this.snapMousePos = this.currentWorldPos.map(a => {
                        return (Math.round(a*2) / 2);
                    });
                    break;
                case 'center':
                    this.snapMousePos = this.currentWorldPos.map(a => Math.round(a));
                    break;
                case 'corner':
                    this.snapMousePos = this.currentWorldPos.map(a => Math.floor(a) + 0.5);
                    break;
                default:
                    this.snapMousePos = this.currentWorldPos;
            }
        }
    }

    getSnapPoint() {
        return this.snapMousePos;
    }

    getWorldPoint() {
        return this.currentWorldPos;
    }

    getRealPoint() {
        return [this.currentMousePos[0], this.currentMousePos[1]];
    }


}